import Loadable from "@loadable/component";

const MyAccountV2 = Loadable(
  () => import(/* webpackChunkName: "my_account_page" */ "./myAccount")
);

export default MyAccountV2;
